var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.articles.length)?_c('section',[_c('JoszakiHeading',{attrs:{"level":2}},[_vm._v(" "+_vm._s(_vm.$t("personProfile.myProfessionsRelatedArticles"))+" ")]),_c('ul',{staticClass:"flex flex-col gap-2"},_vm._l((_vm.articles),function(article){return _c('li',{key:article.seoTitle},[_c('NuxtLink',{staticClass:"text-primary hover:underline",attrs:{"to":_vm.localePath({
            name: 'blogArticlePage',
            params: { articleSeoName: article.seoTitle },
          })}},[_vm._v(" "+_vm._s(article.title)+" ")])],1)}),0)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }